import { useState, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";

import axios from "axios";

import swal from "sweetalert";

import AdminMasterLayout from "../../layouts/admin/MasterLayout";

import Dashboard from "../../components/admin/Dashboard";
import Profile from "../../components/admin/Profile";
import NotFound from "../../components/admin/NotFound";

import AddCategory from "../../components/admin/category/AddCategory";
import ViewCategories from "../../components/admin/category/ViewCategories";
import EditCategory from "../../components/admin/category/EditCategory";

import AddProduct from "../../components/admin/product/AddProduct";
import EditProduct from "../../components/admin/product/EditProduct";
import ViewProducts from "../../components/admin/product/ViewProducts";

import ViewOrders from "../../components/admin/order/ViewOrders";

import PageSpinner from "../../components/spinners/PageSpinner";

import PrivateRoutes from "../PrivateRoutes";

const AdminRoutes = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`/api/isAuthenticated`).then(res => {
            setLoading(false);
        });
    }, []);

    axios.interceptors.response.use(undefined, (err) => {
        if (err.response.status === 401) {
            swal("Unauthorized", err.response.data.message, 'warning');
            navigate('/');
        }
        return Promise.reject(err);
    });

    axios.interceptors.response.use(function (response) {
        return response;
    }, function (err) {
        if (err.response.status === 403) { // Access Denied
            swal("Forbidden", err.response.data.message, 'warning');
            navigate('/403');
        } else if (err.response.status === 404) {
            swal("404 error", "Page / URL you are searching not found", 'warning');
            navigate('/404');
        }
        return Promise.reject(err);
    });

    if (loading) {
        return <PageSpinner />
    }

    return (
        <Routes>
            <Route path="/" element={<AdminMasterLayout />}>

                <Route path="/" element={<PrivateRoutes />}>
                    <Route index element={<Dashboard />} />
                    <Route path="dashboard" element={<Dashboard />} />

                    <Route path="add-category" element={<AddCategory />} />
                    <Route path="view-categories" element={<ViewCategories />} />
                    <Route path="edit-category/:id" element={<EditCategory />} />

                    <Route path="add-product" element={<AddProduct />} />
                    <Route path="view-products" element={<ViewProducts />} />
                    <Route path="edit-product/:id" element={<EditProduct />} />

                    <Route path="profile" element={<Profile />} />

                    <Route path="orders" element={<ViewOrders />} />

                    <Route path="*" element={<NotFound />} />

                </Route>

            </Route>
        </Routes >
    );
}

export default AdminRoutes;